import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, ConsultaAnexosConsumidor } from './types';

export const INITIAL_STATE: ConsultaAnexosConsumidor = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ConsultaAnexosConsumidor {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_ANEXOS_CONSUMIDOR_REQUEST: {
				break;
			}
			case Types.CONSULTA_ANEXOS_CONSUMIDOR_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.CONSULTA_ANEXOS_CONSUMIDOR_FAILURE: {
				draft.status = 400;
				draft.data = action.payload;
				break;
			}
			case Types.CONSULTA_ANEXOS_CONSUMIDOR_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
